import { RepositoryBase } from '@app/repositories/RepositoryBase';

export class SupplierRepository<SupplierModel> extends RepositoryBase<SupplierModel> {
    public constructor() {
        super('supplier');
    }
}
